import { Outlet } from "react-router-dom";
import { TopBar } from "./TopBar.jsx";
import { ManualWelcomeModal } from "./ManualWelcomeModal.jsx";
import { BoardProvider } from "../board/BoardContext.jsx";

/* The signed-in shell. The board is loaded once here and shared by every
   route under it, so moving between the board, a playground and the
   accountability view does not re-fetch it. */
export function Layout() {
  return (
    <BoardProvider>
      <div className="wrap">
        <TopBar />
        <Outlet />
      </div>
      <ManualWelcomeModal />
    </BoardProvider>
  );
}
